import axios from "axios";
const pond1 = async () => {
  try {
    const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/content/point1`
    );
    return response.data;
  } catch (error) {
    console.error("Error saving data:", error);
    // console.clear();
    throw error;
  }
};

export default pond1;
